module.exports = __webpack_public_path__ + "img/congrats.d2276c3a.png";